<template>
  <Layout footer>

    <div class="app-container app-container_warp">
      <div class="flex">

        <div class="online_right ">
          <div class="online_right_title flex">
            <span class="mr-1" style="color:#666;font-size: 18px;">所在位置：</span>
            <NBreadcrumb>
              <NBreadcrumbItem style="color:#666" @click="gotoHome">首页</NBreadcrumbItem>
              <NBreadcrumbItem style="color:#666">搜索结果</NBreadcrumbItem>
            </NBreadcrumb>
          </div>
          <div class="online_right_title_line">
          </div>
          <div>
            <div class="flex hanglin cu" @click="newedit(item,1)" v-for="item in channelNewsList" :key="item.id">
              <div class="jvhao flex ambo"><span></span></div>
              <div class="wenzhang_title">
                {{item.title}}
              </div>
              <div style="flex:1" class="">
                <div class="tags" v-if="item.topFlag==1">
                  置顶
                </div>
                <div class="tags" v-if="item.freshFlag==1">
                  NEW
                </div>
              </div>
              <div class="new_time" v-if="item.releaseDate">[{{item.releaseDate}}]</div>
            </div>
            <div v-if="channelNewsList.length" class=" flex justify-center"
              style="margin-bottom: 100px;margin-top:60px;">
              <NPagination class="mx-auto" show-quick-jumper v-model:page="page" :item-count="pagTotal"
                v-model:page-size="pageSizem">
                <template #prefix> 共 {{ pagTotal }} 条</template>
              </NPagination>
            </div>
            <NEmpty v-if="!channelNewsList.length" class="my-10" description="暂无数据" />

          </div>
        </div>
      </div>
    </div>

    <div class="app-container" v-if="0" style="display:flex;margin-top:40px">
      <div class="he">
        <ul class="list_ej2  mt20">
          <li class="lis" @click="inlis(item)" v-for="item in newList" :key='item.id'>

            <a :style="active==item.id?'color: #409eff;':''" href="javascript:void(0);">{{item.title}} </a>
          </li>
          <!-- <li>
            列表样式的使用
          </li>
          <li>
            列表样式的使用
          </li> -->
        </ul>
      </div>
      <div class="he" style="flex:1;padding-top:30px;">
        <div v-html="htmltext">

        </div>
      </div>
    </div>
  </Layout>
</template>

<script setup>
import Layout from '@/components/Layout';
import {
  computed,
  ref,
  shallowReactive,
  shallowRef,
  onMounted,
  onBeforeUpdate,
  reactive,
  watch,
  nextTick,
  getCurrentInstance,
} from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { channelNewsSearch, pageByCategory, newsDetail, channelNews, siteChannel, channelSingleNew } from '@/api';
const pageSizem = ref(10);
const page = ref(1);
const pagTotal = ref(0);
const router = useRouter();


const route = useRoute();
onMounted(() => {
  console.log(2)
  getchannelNews(route.params.title)
  // getchannelNews(route.params.title)
})

watch(page, () => {
  // classList.value = [];
  // console.log(classList.value.length);
  getchannelNews(route.params.title);
});
watch(page, () => {
  newList.value = [];
  // console.log(classList.value.length);
  // getchannelNews(channelItem);
});
const active = ref('')
const htmltext = ref('')
const newList = ref([])
watch(() => route.params, (val, preVal) => {
  //val为修改后的值,preVal为修改前的值
  getchannelNews(route.params.title)
})
const newsDetails = ref({})
if (route.query.type == 1005) {
  newsDetails.value.id = '-1'

  channelSingleNew({ site: 2, topChannel: 1005 }).then(res => {
    newsDetails.value = res.data
    if (!newsDetails.value.id) {
      newsDetails.value.id = '-1'
    }
  })
}

if (route.query.newid) {
  newsDetails.value.id = route.query.newid

  newedit({ id: route.query.newid })
}
if (route.query.id) {
  getchannelNews({ id: route.query.id })
  // channelNews({ channelId: route.query.id, current: 1, size: 20 }).then(res => {

  //   newList.value = res.data.records
  // })
}
const channelList = ref([])
siteChannel({ site: 2, category: 1 }).then(res => {
  res.data.forEach(element => {
    if (route.query.id) {
      if (element.children) {
        element.children.forEach(item => {
          if (item.id == route.query.id) {
            // pant.value = element
            // channelItem.value = item
            handleClickLevel(item, element)
          }
        })
      } else if (element.id == route.query.id) {
        console.log(element, 666)
        channelItem.value = element
      }
    } else if (route.query.type) {
      if (element.topChannel == route.query.type) {
        if (element.children) {
          handleClickLevel(element.children[0], element, 1)
        } else {
          // channelItem.value = element
          handleClickLevel(element, '', 1)
        }
      }
    }
  });
  channelList.value = res.data
})
function getchannelNews (item) {
  channelNewsSearch({ keyword: item, current: page.value, size: pageSizem.value }).then(res => {
    channelNewsList.value = res.data.records
    pagTotal.value = res.data.total
  })
}
const channelItem = ref({})
function newedit (item, type) {
  if (type) {
    router.push('/news?id=' + channelItem.value.id + '&newid=' + item.id);

  }
  newsDetail({ id: item.id }).then(res => {
    newsDetails.value = res.data

  })
}

function inlis (item) {
  active.value = item.id
  htmltext.value = item.content
}
const channelNewsList = ref([])

const pant = ref({})
const openid = ref('')
function gotoHome () {
  router.push('/');
}
function handleClickLevel (item, pants, type) {
  console.log(item)

  if (pants == 1) {
    if (!type) {
      router.push('/news?id=' + item.id);

    }

    newsDetails.value = {}

    return
  }
  if (!item.children || pants) {
    console.log(1)
    channelItem.value = item
    page.value = 1
    getchannelNews(item)
    // channelNews({ channelId: item.id }).then(res => {
    //   channelNewsList.value = res.data.records
    // })
    if (pants) {
      if (!type) {
        router.push('/news?id=' + item.id);
      }

      pant.value = pants
      openid.value = pants.id

    } else {
      if (!type) {
        router.push('/news?id=' + item.id);

      }
      pant.value = {}
      openid.value = ''
    }
  }
  if (item.children && !pants) {
    if (openid.value != item.id) {
      openid.value = item.id
    } else {
      openid.value = ''

    }

  }

}
</script>

<style scoped>
:deep(.n-breadcrumb-item) {
  font-size: 18px;
}

:deep(.n-tag) {
  color: #5e5d5d;
  font-size: 18px;
}
.hanglin {
  align-items: center;
  padding: 0 30px 0 0px;
  font-size: 18px;
  height: 45px;
  color: #4a4a4a;
}
.hanglin:hover .new_time {
  color: #409eff;
}
.hanglin:hover {
  color: #409eff;
}
.ambo {
  justify-content: center;
  align-items: center;
}
.jvhao {
  font-size: 1px;
  height: 7px;
  width: 7px;
  border: 1px solid #fe0000;
  border-radius: 50%;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  -webkit-text-stroke: 1px #fe0000;
  margin: 0 47px;
}
.jvhao span {
  width: 1px;
  background-color: #fe0000;
  height: 1px;
}
.new_time {
  color: #878787;
  margin-left: 20px;
}
.wenzhang_title {
  /* flex: 1; */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  max-width: 700px;
  -webkit-line-clamp: 1;
  letter-spacing: 1px;
  -webkit-box-orient: vertical;
}
.tags {
  background-color: rgba(220, 38, 38);
  /* width: 60px; */
  padding: 0px 4px;
  font-size: 12px;
  border-radius: 3px;
  margin-left: 20px;
  display: inline-block;
  color: #fff;
  text-align: center;
}
.lis {
  display: block;
  height: 40px;
  color: #444;
  line-height: 40px;
  font-size: 16px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-weight: 400;
}
.lis:hover {
  color: #409eff;
}
.liss {
  line-height: 20px;
  color: #409eff;
}
.list_ej2 {
  width: 300px;
  /* border-right: 1px solid rgb(66, 62, 62); */
  margin-right: 10px;
  height: 600px;
}
.he {
  height: 600px;
  overflow: auto;
}

.online_left {
  width: 338px;
  background: #ffffff;
  border-radius: 20px;
  margin-right: 29px;
  height: 749px;
}
.online_left_title {
  height: 79px;
  box-sizing: border-box;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  text-align: center;
  padding-top: 30px;
}
.online_left_title_line {
  width: 324px;
  height: 1px;
  background: #ebebeb;
  margin: 0 auto 10px;
}
.online_left_nav {
  width: 234px;
  margin-left: 28px;
  min-height: 75px;
  font-size: 22px;
  color: #333;
  /* display: flex; */
  align-items: flex-end;
}
.cu {
  cursor: pointer;
}
.online_left_nav_logo {
  width: 55px;
  max-height: 70px;
  align-self: flex-end;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
.online_left_nav_text_box {
  text-align: left;
  /* flex: 1; */
  border-bottom: 1px solid #ebebeb;
  align-self: flex-end;
  padding-left: 33px;
  padding-right: 33px;
  height: 50px;
  line-height: 50px;
  transition: all 1s;
  border-radius: 15px;
}
.online_left_nav_text_box.active {
  /* background-color: red; */
  /* background: linear-gradient(0deg, #4e77fc 0%, #3c6fef 51%, #4c6dff 100%); */
  border-radius: 15px;
  color: #66a6ff;
}
.online_left_nav:hover .online_left_nav_text_box {
  /* background-color: red; */
  /* background: linear-gradient(0deg, #4e77fc 0%, #3c6fef 51%, #4c6dff 100%); */
  border-radius: 15px;
  color: #66a6ff;
}
.online_right {
  flex: 1;
  background-color: #fff;
  /* min-height: 800px; */
  border-radius: 20px;
  color: #666666;
}

.online_left_nav_text_box.active .roat {
  /* background-color: red; */
  /* background: linear-gradient(0deg, #4e77fc 0%, #3c6fef 51%, #4c6dff 100%); */
  color: #66a6ff;
}
.roat {
  transform: rotate(-90deg);
}
.roat.active {
  transform: rotate(0);
}
.online_right_title {
  height: 79px;
  box-sizing: border-box;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  padding-top: 41px;
  padding-left: 40px;
}
.online_right_title_line {
  /* max-width: 1073px; */
  height: 1px;
  background: #ebebeb;
  margin: 0 auto 32px;
}
.online_right_nav {
  padding-left: 40px;
  font-size: 18px;
}
.online_right_nav_left {
  width: 70px;
}
.online_right_nav_right {
  flex-wrap: wrap;
}
.online_right_nav_box {
  line-height: 32px;
  height: 32px;
  padding: 0 11px;
  margin: 4px;
}
.online_right_nav_box.active {
  background-color: #68bcf1;
  border-radius: 30px;
  color: #fff;
}
.online_right_nav_box:hover {
  background-color: #68bcf1;
  border-radius: 30px;
  color: #fff;
}
.children {
  color: #333333;
  padding-left: 105px;
  height: 60px;
  line-height: 60px;
  cursor: pointer;
}
.children.active {
  color: #66a6ff;
}
.children:hover {
  color: #66a6ff;
}
.newedit {
  background-color: #fff;
  border-radius: 20px;
}
.newedit_title {
  max-width: 1000px;
  text-align: center;
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  margin: 64px auto 36px;
}
.newedit_describe {
  font-size: 20px;
  font-family: Adobe Heiti Std;
  font-weight: normal;
  color: #aca9a9;
  line-height: 20px;
  margin: 0 auto;
  padding-bottom: 45px;
  text-align: center;
}
</style>
<style >
.n-config-provider {
  background-color: #f4f4f4;
}
</style>